module.exports = "/assets/993dc60a26f9c957539668d1125bf27f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/menu/train.png
// module id = 126
// module chunks = 0